;(function($, window, document, undefined) {

  "use strict";

  var pluginName = "floatingSocialShare",
    defaults = {
      place: "top-left",
      counter: true,
      twitter_counter: false,
      target: true,
      buttons: ["facebook", "twitter"],
      title: document.title,
      url: window.location.href,
      description: $('meta[name="description"]').attr("content") || "",
      media: $('meta[property="og:image"]').attr("content") || "",
      text: {'default': 'share with:'},
      text_title_case: false,
      popup: true,
      popup_width: 400,
      popup_height: 300,
      extra_offset: 15
    }, isMobile = updateIsMobile();

  function Plugin (element, options) {
    this.element = element;
    this.settings = $.extend({}, defaults, options);
    this._defaults = defaults;
    this._name = pluginName;
    this.init();
  }

  $.extend(Plugin.prototype, {
    init: function() {

      if ($.inArray(this.settings.place, places) == -1) {
        this.settings.place = this._defaults.place;
      }

      var base = this,
        $template = $("<div>", { id: "floatingSocialShare" }),
        $child = $("<div>", { class: this.settings.place }).appendTo($template),
        _text_default = base.settings.text['default'] || base.settings.text;

      $.each(this.settings.buttons, function(index, value) {
        var v = networks[value],
          $icon = $(v["icon"]),
          _href = v["url"].replace("{url}", encodeURIComponent(base.settings.url))
            .replace("{title}", encodeURIComponent(base.settings.title))
            .replace("{description}", encodeURIComponent(base.settings.description))
            .replace("{media}", encodeURIComponent(base.settings.media)),
          _text_value = base.settings.text[value] || _text_default + value,
          _text_output = base.settings.text_title_case ? title_case(_text_value) : _text_value,
          $component = $("<a>", { title: base.settings.title, class: value + " pop-upper"}).attr("href", _href).attr("title", _text_output).append($icon).addClass("without-counter");
        if (base.settings.target === true) {
          $component.attr("target", "_blank").attr("rel", "noopener noreferrer");
        }
        if (base.settings.counter === true) {
          setShareCount(value, encodeURI(base.settings.url), $component, base.settings.twitter_counter);
        }
        $child.append($component);
      });

      $template.appendTo(this.element);

      var links = $(this.element).find(".pop-upper");

      if (this.settings.popup === true) {
        links.on("click", function(event) {
          event.preventDefault();
          openPopUp($(this).attr("href"), $(this).attr("title"), base.settings.popup_width, base.settings.popup_height);
        });
      }

      setMobileCss(links);
      checkPlacePosition($child, base.settings.place, base.element, base.settings.extra_offset);

      $(window).resize(function() {
        setMobileCss(links);
        checkPlacePosition($child, base.settings.place, base.element, base.settings.extra_offset);
        updateIsMobile();
      });

    }

  });

  var places = ["content-left", "content-right", "top-left", "top-right"],
    networks = {
      "facebook" : {
        icon: "<svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'><path d='M22.676 0H1.324C.593 0 0 .593 0 1.324v21.352C0 23.408.593 24 1.324 24h11.494v-9.294H9.689v-3.621h3.129V8.41c0-3.099 1.894-4.785 4.659-4.785 1.325 0 2.464.097 2.796.141v3.24h-1.921c-1.5 0-1.792.721-1.792 1.771v2.311h3.584l-.465 3.63H16.56V24h6.115c.733 0 1.325-.592 1.325-1.324V1.324C24 .593 23.408 0 22.676 0'/></svg>",
        url:"https://www.facebook.com/sharer/sharer.php?u={url}&t={title}"
      },
      "linkedin": {
        icon: "<svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'><path d='M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z'/></svg>",
        url: "https://www.linkedin.com/shareArticle?mini=true&url={url}&title={title}&summary={description}&source="
      },
      "pinterest":  {
        icon: "<svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'><path d='M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.162-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.099.12.112.225.085.345-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.401.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.354-.629-2.758-1.379l-.749 2.848c-.269 1.045-1.004 2.352-1.498 3.146 1.123.345 2.306.535 3.55.535 6.607 0 11.985-5.365 11.985-11.987C23.97 5.39 18.592.026 11.985.026L12.017 0z'/></svg>",
        url: "https://www.pinterest.com/pin/create/button/?url={url}&description={description}&media={media}"
      },
      "twitter": {
        icon: "<svg role='img' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'><path d='M23.954 4.569c-.885.389-1.83.654-2.825.775 1.014-.611 1.794-1.574 2.163-2.723-.951.555-2.005.959-3.127 1.184-.896-.959-2.173-1.559-3.591-1.559-2.717 0-4.92 2.203-4.92 4.917 0 .39.045.765.127 1.124C7.691 8.094 4.066 6.13 1.64 3.161c-.427.722-.666 1.561-.666 2.475 0 1.71.87 3.213 2.188 4.096-.807-.026-1.566-.248-2.228-.616v.061c0 2.385 1.693 4.374 3.946 4.827-.413.111-.849.171-1.296.171-.314 0-.615-.03-.916-.086.631 1.953 2.445 3.377 4.604 3.417-1.68 1.319-3.809 2.105-6.102 2.105-.39 0-.779-.023-1.17-.067 2.189 1.394 4.768 2.209 7.557 2.209 9.054 0 13.999-7.496 13.999-13.986 0-.209 0-.42-.015-.63.961-.689 1.8-1.56 2.46-2.548l-.047-.02z'/></svg>",
        url:"https://twitter.com/intent/tweet?text={title}%20{url}"
      },
    };

  function openPopUp(url, title, width, height) {
    var w = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width,
      h = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height,
      left = (w / 2) - (width / 2) +  10,
      top  = (h / 2) - (height / 2) +  50;
    window.open(url, title, "scrollbars=yes, width=" + width + ", height=" + height + ", top=" + top + ", left=" + left).focus();
  }

  function title_case(str) {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }

  function shorten(num) {
    if (num >= 1000000000) {
      return (num / 1000000000).toFixed(1).replace(/\.0$/, "") + "G";
    } else if (num >= 1000000) {
      return (num / 1000000).toFixed(1).replace(/\.0$/, "") + "M";
    } else if (num >= 1000) {
      return (num / 1000).toFixed(1).replace(/\.0$/, "") + "K";
    } else {
      return num;
    }
  }

  function setMobileCss(objects) {
    $.each(objects, function() {
      if (isMobile) {
        $(this).css("width", 100 / objects.length + "%");
        $(this).removeClass('with-counter-desktop');
      } else {
        $(this).removeAttr("style");
        if ($(this).find("span.shareCount").length > 0) {
          $(this).addClass("with-counter-desktop");
        }
      }
    });
  }

  function checkPlacePosition($child, position, element, extraOffset) {
    if (isMobile === false && $.inArray(position, ["content-right", "content-left"]) != -1) {
      var initialOffset = position === "content-right" ? element.offsetWidth : -75;
      $child.css("margin-left", initialOffset + extraOffset);
    } else {
      $child.css("margin-left", 0);
    }
  }

  function getWidth() {
    return window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
  }

  function updateIsMobile() {
    var mobile = getWidth() < 961;
    if (typeof isMobile !== "undefined") {
      isMobile = mobile;
    }
    return mobile;
  }

  function appendButtons(count, $component) {
    if (count && count > 0) {
      $component.append($("<span>", { class: "shareCount" }).append(shorten(count))).removeClass("without-counter");
      if (isMobile === false) {
        $component.addClass("with-counter-desktop");
      }
    }
  }

  function issetOrZero(fn) {
    var value;
    try {
      value = fn();
    } catch (e) {
      value = 0;
    }
    return value;
  }

  function setShareCount(network, url, $component, twitter_counter) {
    switch(network) {
      case "facebook":
        $.getJSON("https://graph.facebook.com/?id=" + url + "&callback=?", function(data) {
          appendButtons(issetOrZero(function () { return data.share.share_count; }), $component);
        });
        break;
      case "linkedin":
        $.getJSON("https://www.linkedin.com/countserv/count/share?url=" + url + "&callback=?", function(data) {
          appendButtons(issetOrZero(function () { return data.count; }), $component);
        });
        break;
      case "pinterest":
        $.getJSON("https://api.pinterest.com/v1/urls/count.json?url=" + url.replace(/\/+$/, '/') + "&callback=?", function(data) {
          appendButtons(issetOrZero(function () { return data.count; }), $component);
        });
        break;
      case "twitter":
        if (twitter_counter == true) {
          $.getJSON("https://opensharecount.com/count.json?url=" + url + "&callback=?", function(data) {
            appendButtons(issetOrZero(function () { return data.count; }), $component);
          });
        }
        break;
      default:
        return -1;
    }
  }

  $.fn[pluginName] = function(options) {
    return this.each(function() {
      if (!$.data(this, "plugin_" + pluginName)) {
        $.data(this, "plugin_" + pluginName, new Plugin(this, options));
      }
    });
  };

})(jQuery, window, document);